import {Component} from '@angular/core';

@Component({
  selector: 'app-cmi5-termination-slide',
  templateUrl: './cmi5-termination-slide.component.html',
  styleUrls: ['./cmi5-termination-slide.component.scss'],
})
export class Cmi5TerminationSlideComponent {}
